export default "__VITE_ASSET__brwRkcBp__"